// src/hooks/usePopup.ts (or .js if you're not using TypeScript)
import { toast } from 'react-toastify';

const useToastify = () => {
  const showNotification = (message, type = 'default', duration = 3000, position = 'bottom-center', minWidth = "600px", maxWidth = "800px") => {
    toast(message, {
      type,
      autoClose: duration,
      position: position,
      style: {
    maxWidth: maxWidth,
    minWidth: minWidth,
  },
   className: 'submenu-content'
    });
  };

  return { showNotification };
};

export default useToastify;
